module.exports = __webpack_public_path__ + "static/media/Pfeilzeichen.eac356b7.svg";